<h1 mat-dialog-title>{{'Slides list' | translate}}</h1>
<div mat-dialog-content>
    <mat-list *ngIf="sliders">
        <mat-list-item *ngFor="let item of sliders" (click)="selectItem(item)">
            #{{item.id}} {{item.name}}
        </mat-list-item>
    </mat-list>

    <ng-container *ngIf="!sliders || !sliders.length">
        <i>{{'No data' | translate}}...</i>
    </ng-container>
</div>

<div mat-dialog-actions>
    <button mat-raised-button color="primary" [mat-dialog-close]="true">
        {{'Close' | translate}}
    </button>
</div>